import React from "react";
import { node } from "prop-types";
import { Dropdown } from "#library/components/Dropdown";
import { MenuBarItem } from "#library/components/MenuBar/Item/MenuBarItem";
export var MenuBarDropdown = function MenuBarDropdown(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(MenuBarItem, null, /*#__PURE__*/React.createElement(Dropdown, null, children));
};
MenuBarDropdown.propTypes = {
  children: node.isRequired
};